document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".main-product-image");
  images.forEach(function (img) {
    let spinning = false;
    let rotation = 0;
    let lastTimestamp = null;
    let reqId;

    function spin(ts) {
      if (!lastTimestamp) lastTimestamp = ts;
      const delta = ts - lastTimestamp;
      lastTimestamp = ts;
      // 360deg every 3s
      rotation += (delta / 3000) * 360;
      img.style.transform = `scale(1.02) rotate(${rotation}deg)`;
      if (spinning) {
        reqId = requestAnimationFrame(spin);
      }
    }

    img.addEventListener("mouseenter", () => {
      spinning = true;
      lastTimestamp = null;
      reqId = requestAnimationFrame(spin);
    });
    img.addEventListener("mouseleave", () => {
      spinning = false;
      cancelAnimationFrame(reqId);
      // Keep at last rotation
      img.style.transform = `scale(1.0) rotate(${rotation}deg)`;
    });
  });
});
